<td class="adm-td" *ngIf="userSupper == 1"></td>
<td class="good-mobile">
  <span class="wh-name">↳ {{ wh.name }}</span>
</td>
<td class="good-desktop"></td>
<td></td>
<td></td>
<td></td>
<td>
  <div>{{ wh.expire }}</div>
  <div class="wh-til" *ngIf="wh.tilTime > 0">замовити до {{ wh.tilTime }}:00</div>
</td>
<td class="adm-td" *ngIf="isAdmin && roleId == 0">{{ wh.count }}</td>
<td class="label-color">
  {{ sup.supplier }}
  <div class="wh-name">{{ wh.name }}</div>
</td>
<td class="missing-quantity">{{ wh.count > 9 ? '>10' : wh.count }}</td>
<td>{{ sup.price }} {{ currencyName }}</td>
<td class="count-basket">
  <div class="buttons-count-to-basket">
    <span class="minus" (click)="minusCount()">-</span>
    <span class="number contenteditable"
          appContenteditable
          [onlyNumber]="true"
          [(ngModel)]="wh.countBasket"></span>
    <span class="plus" (click)="plusCount()">+</span>
  </div>
</td>
<td>
  <span class="missing-quantity-mobile" [class.fire]="sup.turnOn" (click)="addToBasketMobile()">
    {{ wh.count > 9 ? '>10' : wh.count }} шт.
  </span>
  <a class="add-to-basket" [class.fire]="sup.turnOn" (click)="addToBasket()"></a>
</td>
